var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeiboDesktopLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 11,
  viewBox: "0 0 11 11",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m3.459 4.169.714.714-2.419 2.42a1.003 1.003 0 0 0-.078 1.323l.084.094.549.549a1 1 0 0 0 1.418.006l2.419-2.419.716.716-3.167 3.169a.997.997 0 0 1-1.412 0L.29 8.749a1.003 1.003 0 0 1 .001-1.411zm4.5-1.794.717.717-5.58 5.58-.717-.716zM8.746.292l1.993 1.994c.39.39.384 1.026 0 1.411L7.58 6.855l-.717-.717 2.416-2.415c.359-.36.385-.929.078-1.324l-.084-.095-.548-.548a1 1 0 0 0-1.419-.006L4.89 4.165l-.714-.714L7.334.294A.997.997 0 0 1 8.746.292"
})));
export default SvgWeiboDesktopLink;